import React from "react";
import "./header.css";
import people from "../../assets/people.png";
import ai from "../../assets/ai.png";

const Header = () => {
  return (
    <div className="gpt3__header section__padding" id="home">
      <div className="gpt3__header-content">
        <h1 className="gradient__text">
          Let's Build Something amazing with GPT-3 Open AI
        </h1>
        <p>
          Hello there, I have completed this project, tweaking along with JSM and I have learned quite a stuff like FILES and FOLDER structure, breaking a big projects in many small parts and reuse the already defined components also the best way to create a react app however I like working with @mui-material.
        </p>
        <div className="gpt3__header-content__input">
          <input type="email" placeholder="Your Email Address" />
          <button type="button" onClick={()=>{alert("rohitpandey73551@gmail.com")}}>Get Started</button>
        </div>
        <div className="gpt3__header-content__people">
          <img src={people} alt="people" />
          <p>1,600 people requested the access.</p>
        </div>
      </div>
      <div className="gpt3__header-img">
        <img src={ai} alt="ai" />
      </div>
    </div>
  );
};

export default Header;
